import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import Loader from "../../../../components/v2/Loaders/FullScreenLoader/Loader";
import OTPModal from "../../../../components/v2/Modals/OTPModal";
import { selectOTPModal } from "../../../../store/common/selectors";
import { showOTPModal } from "../../../../store/common/slice";

const RestrictedPrivateRoute = ({ showOTPModal, otpModal, passThrough = false }) => {
  const [isLoading, setIsLoading] = useState(!passThrough);

  useEffect(() => {
    if (passThrough) return;

    try {
      showOTPModal(true);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  }, [showOTPModal, passThrough]);

  if (isLoading) return <Loader />;
  if (!passThrough && otpModal) return <OTPModal {...otpModal} />;

  return <Outlet />;
};

const mapStateToProps = createStructuredSelector({
  otpModal: selectOTPModal,
});

const mapDispatchToProps = {
  showOTPModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(RestrictedPrivateRoute);
